// Route params are unvalidated url text. This is the one place they become an
// id, so nothing downstream has to guess.
export const parseIdUser = (raw: unknown): number | null => {
    if (typeof raw !== "string" || !/^\d+$/.test(raw)) {
        return null;
    }

    const idUser = Number(raw);

    // Past the safe integer range Number() mangles the value silently.
    if (idUser <= 0 || !Number.isSafeInteger(idUser)) {
        return null;
    }

    return idUser;
};
